import { TITLE_LEVEL_OPTIONS, UI_FIELD_DEFAULT_OPTION, sizeTokenOptionsWithDefault, } from './token-options.js';
export const LIST_ITEM_FIELDS = [
    {
        key: 'listItem.user.avatarSize',
        group: '사용자 행',
        label: '프로필 사진 크기',
        help: '팔로워·팔로잉·채팅방 참여자 등 사용자 목록 행(UserInfoRow)의 프로필 사진 지름',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.m-plus',
        min: 24,
        max: 56,
    },
    {
        key: 'listItem.user.gap',
        group: '사용자 행',
        label: '사진·닉네임 간격',
        help: '사용자 목록 행에서 프로필 사진과 닉네임 사이 간격',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 간격 (앱 7px·웹 8px)'),
    },
    {
        key: 'listItem.user.paddingY',
        group: '사용자 행',
        label: '위아래 안쪽 여백',
        help: '팔로우 버튼이 있는 사용자 목록 행(UserListItem — 팔로워·팔로잉 목록) 위아래 여백 — 행 사이 간격이 이만큼 바뀐다',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 7px·웹 8px)'),
    },
    {
        key: 'listItem.iconRow.iconSize',
        group: '아이콘 메뉴 행',
        label: '아이콘 크기',
        help: '더보기·수정/삭제·신고 등 아래에서 올라오는 메뉴의 아이콘+글자 행(ItemRowWithIcon) 아이콘 크기. 화면에서 아이콘 크기를 따로 정한 행은 그대로',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 12,
        max: 48,
    },
    {
        key: 'listItem.iconRow.gap',
        group: '아이콘 메뉴 행',
        label: '아이콘·글자 간격',
        help: '아이콘 메뉴 행에서 아이콘과 글자 사이 간격',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 간격 (앱 14px·웹 16px)'),
    },
    {
        key: 'listItem.menu.paddingX',
        group: '메뉴 행',
        label: '좌우 안쪽 여백',
        help: '마이페이지·설정의 메뉴 행(MenuItem — 이름 오른쪽에 > 표시) 양옆 여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 14px·웹 16px)'),
    },
    {
        key: 'listItem.menu.paddingY',
        group: '메뉴 행',
        label: '위아래 안쪽 여백',
        help: '메뉴 행 위아래 여백 — 행 높이가 이만큼 바뀐다',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 17.5px·웹 20px)'),
    },
    {
        key: 'listItem.menu.titleLevel',
        group: '메뉴 행',
        label: '메뉴 이름 글자 크기',
        help: '메뉴 행 이름의 글자 크기(제목 단계). 오른쪽 보조 글자는 그대로',
        type: 'enum',
        defaultValue: '3',
        options: TITLE_LEVEL_OPTIONS,
    },
];
//# sourceMappingURL=listItem.js.map